module.exports = __webpack_public_path__ + "static/Tarra-7f6398a7ad737796bb75e23e328da974.jpg";